import { cn } from '../../lib/utils';
import './ui.css';

const variantClass = {
  default: 'ui-badge-default',
  secondary: 'ui-badge-secondary',
  outline: 'ui-badge-outline',
};

export function Badge({ className, variant = 'default', ...props }) {
  return <span className={cn('ui-badge', variantClass[variant], className)} {...props} />;
}
